import React, { useEffect, useState } from "react";
import { CustomerMessages } from "@languages/interfaces/customerMessages";

/** hooks */
import { useAuth } from "@hooks/useAuth";

import * as appIcons from "@assets/applications";

import useTheme from "@styles/useTheme";
import useTranslation from "@languages/useTranslation";

import SidebarMenu from "@atoms/SidebarMenu";
import { useSidebarMenu } from "@hooks/menuItensContext";

export interface MenuItem {
  id: string;
  title: string;
  icon: string;
  link: string;
  onClick?: () => void;
  children?: React.ReactNode;
  onlyAdmin?: boolean;
  hidden?: boolean;
}

export enum ModuleIds {
  CONTRACT = "3",
  CERTIFICATE = "7",
  CONCRETING = "4",
  INVOICE = "5",
  CONCRETING_REQUEST = "2",
  CLIENT = "8"
}

export enum ModuleNames {
  CONTRACT = "/contracts",
  CERTIFICATE = "/certificates",
  CONCRETING = "/concretings",
  INVOICE = "/invoices",
  CONCRETING_REQUEST = "/concreting-requests",
  CLIENT = "/clients"
}

export const SidebarMenuItems: MenuItem[] = [
  {
    id: "1",
    title: CustomerMessages.applicationDashboard,
    icon: appIcons.dashboard,
    link: "/",
    hidden: false
  },
  {
    id: "2",
    title: CustomerMessages.applicationConcretingRequest,
    icon: appIcons.menuConcretingRequest,
    link: "/concreting-requests",
    hidden: false
  },
  {
    id: "3",
    title: CustomerMessages.applicationContract,
    icon: appIcons.menuContract,
    link: "/contracts",
    hidden: false
  },
  {
    id: "4",
    title: CustomerMessages.applicationConcreting,
    icon: appIcons.menuConcreting,
    link: "/concretings",
    hidden: false
  },
  {
    id: "5",
    title: CustomerMessages.applicationInvoice,
    icon: appIcons.menuInvoice,
    link: "/invoices",
    hidden: false
  },
  {
    id: "6",
    title: CustomerMessages.applicationConcretingApproval,
    icon: appIcons.menuConcretingApproval,
    link: "/concreting-approvals",
    onlyAdmin: true
  },
  {
    id: "7",
    title: CustomerMessages.applicationCertificate,
    icon: appIcons.menuCertificate,
    link: "/certificates",
    hidden: false
  },
  {
    id: "8",
    title: CustomerMessages.applicationClient,
    icon: appIcons.menuClient,
    link: "/clients",
    hidden: false
  },
  {
    id: "9",
    title: CustomerMessages.applicationPermission,
    icon: appIcons.menuPermission,
    link: "/permissions",
    onlyAdmin: true
  }
];

const SidebarMenus: React.FC = () => {
  const { menuItems } = useSidebarMenu();
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <>
      {menuItems.map(({ id, title, icon, link, onlyAdmin, hidden }) => {
        if (onlyAdmin && !user.admin) return null;
        if (!user.admin && hidden) return null;

        return (
          <SidebarMenu
            key={`${id}_${title}`}
            id={id}
            title={t(title)}
            icon={icon}
            link={link}
            identifierColor={theme.colors.tertiary}
          />
        );
      })}
    </>
  );
};

export default SidebarMenus;
